import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS } from '@change-corgi/fcm/configs';

export async function shouldLoadShareRecommendations(utilityContext: UtilityContext) {
	const fcm = await utilityContext.fcm.get({
		starterExperienceShareRecommendationsConfig: FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
	});

	return fcm.starterExperienceShareRecommendationsConfig.isEnabled;
}
